export default "__VITE_ASSET__qdiUD7I2__"